var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45 4C2.17152 4 1.90445 3.88938 1.70754 3.69246C1.51062 3.49555 1.4 3.22848 1.4 2.95C1.4 2.67152 1.51062 2.40445 1.70754 2.20754C1.90445 2.01062 2.17152 1.9 2.45 1.9C2.72848 1.9 2.99555 2.01062 3.19246 2.20754C3.38938 2.40445 3.5 2.67152 3.5 2.95C3.5 3.22848 3.38938 3.49555 3.19246 3.69246C2.99555 3.88938 2.72848 4 2.45 4ZM13.587 7.206L7.287 0.906C7.035 0.654 6.685 0.5 6.3 0.5H1.4C0.623 0.5 0 1.123 0 1.9V6.8C0 7.185 0.154 7.535 0.413 7.787L6.706 14.087C6.965 14.339 7.315 14.5 7.7 14.5C8.085 14.5 8.435 14.339 8.687 14.087L13.587 9.187C13.846 8.935 14 8.585 14 8.2C14 7.808 13.839 7.458 13.587 7.206Z",
    fill: "#AEB9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTag);
export default __webpack_public_path__ + "static/media/manage-tag.2afda4cdb2e27aeb0285fed13add0345.svg";
export { ForwardRef as ReactComponent };